module.exports = __webpack_public_path__ + "static/media/sound-button.a91f2198.svg";